import type { AppFeatures } from "@/app/featureFlags/types";
import { growthbook } from "@/lib/growthbook";

export { useFeatureIsOn } from "@growthbook/growthbook-react";

export function isFeatureOn(featureKey: keyof AppFeatures) {
  return growthbook.isOn(featureKey);
}
